import { useTranslation } from 'react-i18next'

const TokenSelectorNoTokens = () => {
  const { t } = useTranslation('tokenSelector', { keyPrefix: 'tokenList' })

  return (
    <div className='no-tokens-found'>
      <div className='text-main text-lg font-semibold'>{t('noTokens')}</div>
      <div className='mt-3 text-main-muted text-sm'>
        {t('noTokensSuggestion')}
      </div>
    </div>
  )
}

export default TokenSelectorNoTokens
